import { Card } from "antd"
import styled from "styled-components"

const CardStyle = styled(Card)`
  border: 1px solid ${(props) => props.theme.colorbluegreylight};
  box-shadow: 0px 7px 33px -2px rgba(28, 39, 49, 0.05);
  max-height: calc(100vh - 357px);
  overflow: auto;
  background: transparent;

  .ant-card-body {
    border-radius: 8px;
    padding-left: 0;
    padding-right: 0;
  }
`
export default CardStyle